import { UserGetUseCase } from '../../../../application';

export default class UserGetService {

    async RequestData(event) {
        const data = await UserGetUseCase(event);
        return data;
    }
}
